export default "__VITE_ASSET__DXptEUOI__"